// apiConfig.js
// Use proxy in development, full URL in production

const API_BASE_URL = process.env.NODE_ENV ===  "development" ? "http://localhost:8000/api/v1" : "https://api.bsf5050.com/api/v1" ;


export default API_BASE_URL;
